<template>
  <div
    v-if="preparedMedia"
    class="media-view"
  >
    <v-progress-circular
      v-if="!loaded"
      indeterminate
      class="media-view__loader"
      color="white"
    />
    <transition name="fade">
      <img
        v-if="preparedMedia.type === 'image'"
        v-show="loaded"
        ref="parallaxEl"
        :src="preparedMedia.url"
        alt=""
        :style="style"
        @load="onLoaded"
      >
      <video-player
        v-else
        ref="parallaxEl"
        :options="generateVideoOptions()"
        :active="active"
        :style="style"
      />
    </transition>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import { MediaItem, extensions } from '../../middleware/MediaItem'

import VideoPlayer from './VideoPlayer.vue'

@Component({
  components: {
    VideoPlayer,
  },
})
export default class MediaView extends Vue {
  @Prop({ type: String }) media!: string
  @Prop({ type: Boolean }) active!: boolean

  loaded: boolean = false
  style = { top: 0 }

  get preparedMedia ():MediaItem {
    const fileExtFull = /^.+\.([^.]+)$/.exec(this.media)
    if (!fileExtFull || !fileExtFull.length) return null

    const fileExt = fileExtFull[1].replace(/\?.*/, '')

    return extensions.reduce((acc, i) => {
      if (i.formats.includes(fileExt)) {
        acc = { ...acc, type: i.type, ext: fileExt }
      }
      return acc
    }, {
      url: this.media,
      type: '',
      ext: '',
      file: '',
      id: '',
    })
  }

  generateVideoOptions () {
    return {
      autoplay: false,
      controls: false,
      muted: true,
      loop: true,
      sources: [
        {
          src: this.preparedMedia.url,
          type: `video/${this.preparedMedia.ext}`,
        },
      ],
    }
  }

  onLoaded () {
    this.loaded = true
  }

  handleScroll () {
    if (this.$refs.parallaxEl) {
      const pageTop = window.scrollY
      const newTop = (pageTop * 0.5)
      const style = (this.$refs.parallaxEl as any).$el
        ? (this.$refs.parallaxEl as any).$el.style
        : (this.$refs.parallaxEl as any).style

      style.transform = `translate3d(0, ${newTop}px, 0)`
      style.height = `calc(${style.height} - ${pageTop})`
    }
  }

  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  }

  beforeUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss">
  .media-view {
    height: 100%;
    width: 100%;
    position: relative;
    img {
      display: block;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(270deg, rgba(0, 0, 0, 6e-05) 0%, rgba(0, 0, 0, 0.457654) 100%);
    }
    &__loader {
      position: absolute;
      top: calc(50% - 1rem);
      left: calc(50% - 1rem);
    }
  }
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active up to version 2.1.8 */ {
  opacity: 0;
}
</style>
